import { Action, createAction, props } from '@ngrx/store';
import { Payment } from '../../models/payment';
import { FilterState } from 'src/app/modules/shared/models/filter-state';
import { RegisterDirectPayment } from '../../models/register-payment';
import { PaymentIntent, PaymentIntentRequest } from '../../models/paymentIntent';
import { GiftCard } from '../../models/gift-card';
import { Booking } from 'src/app/modules/booking/models/booking';


export const AddPayment = createAction('ADD PAYMENT', props<{ payment: Payment }>());

export const AddPayments = createAction('ADD PAYMENTS', props<{ payments: Payment[] }>());

export const AddError = createAction('ADD PAYMENT ERROR', props<{ error: any }>());

export const AddTotalCount = createAction('ADD PAYMENT TOTAL COUNT', props<{ totalCount: number }>());

export const AddPaymentFilter = createAction('ADD PAYMENT FILTER', props<{ filter: FilterState }>());

export const RemovePaymentFilter = createAction('REMOVE PAYMENT FILTER');

export const AddPaymentIntent = createAction('ADD PAYMENT INTENT', props<{ paymentIntent: PaymentIntent }>());

export const RemovePaymentIntent = createAction('REMOVE PAYMENT INTENT');

export const AddGiftCard = createAction('ADD GIFT CARD', props<{ isValid: boolean }>());

export const RemoveGiftCard = createAction('REMOVE GIFT CARD');


// Effects actions


export const FETCH_PAYMENTS = '[Api] FETCH PAYMENTS';

export const FetchPayments = createAction('[Api] FETCH PAYMENTS', props<{ name: string, pageIndex: number,
    pageSize: number, guideId?: string, experienceId?: string, userId?: string }>());

export const GetPayment = createAction('[Api] GET PAYMENT', props<{ id: string }>());

export const RegisterPayment = createAction('[Api] REGISTER PAYMENT', props<{ change: Partial<RegisterDirectPayment> }>());

export const FetchPaymentIntent = createAction('[Api] FETCH PAYMENT INTENT', props<{ paymentIntentParams: PaymentIntentRequest, isAgreedAgeRestriction: boolean }>());

export const ConfirmPaymentTransaction = createAction('[Api] CONFIRM PAYMENT TRANSACTION', props<{ transactionId: string, booking: Booking, participants: number }>());

export const CheckGiftCardCode = createAction('[Api] CHECK GIFT CARD CODE', props<{ giftCode: string, bookingId: string }>());

export const ConfirmGiftCardPaymentTransaction = createAction('[Api] CONFIRM GIFT CARD PAYMENT TRANSACTION', props<{ giftCard: GiftCard, booking: Booking }>());

